<div class="modal active">
  <div class="modal__container">
    <div class="fields">
      <h2>Available Coordinate Points</h2>
      <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngCoordinatePointsForm" #ngForm="ngForm" id="CoordinatePointsForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4 *ngIf="!isFromAirSpaceBoundary">Select the Coordinate Point to use in the Procedure.</h4>
                <h4 *ngIf="isFromAirSpaceBoundary">Select the Coordinate Point to use in the Air Space Boundary.</h4>
                <span> </span>
              </div>
              <div class="table-fields">
                <div>
                    <table>
                      <caption>
                      </caption>
                      <thead>
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Name</th>
                          <th scope="col">Type</th>
                          <th scope="col">Active</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr mdbTableCol *ngFor="let el of selectCoordinatePointService.coordinatePointsModal ; let i = index"
                        (click)="selectCoordinatePointService.selectRow(el, selectCoordinatePointService.coordinatePointsModal)"
                        [class.highlighted]="el.isselected">
                          <td>{{ el.coordpointid }}</td>
                          <td>{{ el.name }}</td>
                          <td>{{ el.type }}</td>
                          <td>{{ el.published }}</td>
                        </tr>
                      </tbody>
                    </table>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" class="blue" (click)="addCoordinatePoint()">
              Save
            </button>
            <button class="gray" (click)="cancel()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
